import { FC } from 'react';
import { Image } from 'antd';
import { Link } from 'react-router-dom';
import SectionStyled from './styles';

const PageHome: FC = () => {
  return (
    <SectionStyled>
      <Image src={'Images/homePage/Takumi_app_A1Panel_2_OL-1.jpg'} preview={false} />
      <Image src={'Images/homePage/Takumi_app_A1Panel_2_OL-2.jpg'} preview={false} />
      <Image src={'Images/homePage/Takumi_app_A1Panel_2_OL-3.jpg'} preview={false} />
      <Link
        title="プライバシーポリシーへ"
        to="/terms"
        style={{ textAlign: 'end', paddingRight: '10px' }}
      >
        プライバシーポリシーへ
      </Link>
    </SectionStyled>
  );
};

export default PageHome;
